import { useUser } from 'contexts/UserContext'

/**
 * Hook per verificare se un modulo è abilitato per il tenant corrente.
 *
 * @param moduleName - Nome del modulo da verificare (es: 'leads', 'projects')
 * @returns true se il modulo è abilitato, false altrimenti
 *
 * @example
 * const isLeadsEnabled = useModuleEnabled('leads')
 * if (isLeadsEnabled) {
 *   // mostra funzionalità leads
 * }
 */
export function useModuleEnabled(moduleName: string): boolean {
  const { user } = useUser()

  if (!user?.enabled_modules) {
    return false
  }

  return user.enabled_modules[moduleName] === true
}
